import { render, staticRenderFns } from "./VoteButtonNew.vue?vue&type=template&id=76fc43cf&"
import script from "./VoteButtonNew.vue?vue&type=script&lang=ts&"
export * from "./VoteButtonNew.vue?vue&type=script&lang=ts&"
import style0 from "./VoteButtonNew.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports